/**
 * Clean Swym Popup Text
 * Removes only the quantity text (e.g., "1 Quantité", "2 Quantité") from the popup
 * Keeps product name and variant details (color, size, etc.)
 */

(function() {
  'use strict';

  function cleanSwymPopupText() {
    const popupContent = document.querySelector('.swym-cc-sfl-popup-content p');

    if (popupContent) {
      // Get the full text content
      const fullText = popupContent.textContent;

      // Check if quantity pattern exists
      if (/\d+\s*Quantit[éy]/i.test(fullText)) {
        // Get all child nodes (including text nodes and elements)
        const childNodes = Array.from(popupContent.childNodes);

        // Find the text nodes that contain the quantity pattern
        let foundQuantityStart = false;
        const nodesToRemove = [];

        childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent.trim();

            // Check if this is a digit (quantity number)
            if (/^\d+$/.test(text)) {
              foundQuantityStart = true;
              nodesToRemove.push(node);
            }
            // If we found the number, check for following nodes (space and "Quantité")
            else if (foundQuantityStart) {
              if (text === '' || /^Quantit[éy]$/i.test(text)) {
                nodesToRemove.push(node);
                // Stop after finding "Quantité"
                if (/^Quantit[éy]$/i.test(text)) {
                  foundQuantityStart = false;
                }
              }
            }
          }
        });

        // Remove the identified nodes
        if (nodesToRemove.length > 0) {
          nodesToRemove.forEach(node => {
            node.parentNode.removeChild(node);
          });
          console.log('[Swym Cleaner] Removed quantity from popup');
        }
      }
    }
  }

  // Multiple strategies to catch the popup

  // Strategy 1: MutationObserver to detect when the popup appears
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          // Check if the added node or its descendants contain the popup
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('swym-cc-sfl-popup-content')) {
              setTimeout(cleanSwymPopupText, 50);
            } else if (node.querySelector && node.querySelector('.swym-cc-sfl-popup-content')) {
              setTimeout(cleanSwymPopupText, 50);
            }
          }
        });
      }

      // Also check for text changes within the popup
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        const popup = document.querySelector('.swym-cc-sfl-popup-content');
        if (popup && mutation.target.nodeType === Node.TEXT_NODE) {
          setTimeout(cleanSwymPopupText, 50);
        }
      }
    });
  });

  // Start observing the body for changes
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Strategy 2: Check periodically for the popup (fallback)
  let checkInterval;
  function startPeriodicCheck() {
    checkInterval = setInterval(() => {
      const popup = document.querySelector('.swym-cc-sfl-popup-content p');
      if (popup && popup.textContent.match(/\d+\s+Quantit[éy]/i)) {
        cleanSwymPopupText();
      }
    }, 500);
  }

  // Strategy 3: Listen to click events that might trigger the popup
  document.addEventListener('click', function(e) {
    // Check if click might trigger Swym popup
    if (e.target.closest('.swym-remove-product-icon') ||
        e.target.closest('[data-swym-remove-product]')) {
      setTimeout(cleanSwymPopupText, 100);
      setTimeout(cleanSwymPopupText, 300);
      setTimeout(cleanSwymPopupText, 500);
    }
  }, true);

  // Initialize
  function init() {
    console.log('[Swym Cleaner] Initialized');
    startPeriodicCheck();
    cleanSwymPopupText();
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Clean up interval when page is hidden
  document.addEventListener('visibilitychange', function() {
    if (document.hidden && checkInterval) {
      clearInterval(checkInterval);
    } else if (!document.hidden && !checkInterval) {
      startPeriodicCheck();
    }
  });
})();
